import { PanelList } from "components/PanelList/PanelList";
import { CompactTourListItem } from "./CompactTourListItem";

interface Props {
  tourIds: string[];
  hoverColor?: string;
}

// todo - code more or less identical to tournament equivalent
// look to share code where possible
export const CompactTourList = ({ tourIds, hoverColor }: Props) => {
  return (
    <PanelList hoverColor={hoverColor}>
      {tourIds.map((tourId) => (
        <CompactTourListItem key={tourId} tourId={tourId} />
      ))}
    </PanelList>
  );
};
